import { Component } from "@angular/core";

@Component({
    selector: "app-letter",
    template: "<router-outlet></router-outlet>",
})
export class LetterComponent { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/letter/letter.componen.ts